/**
 * O playground só existe em dev e staging: em produção a rota e o item de menu
 * nem são registrados (e o backend responde 404). Lê o `VITE_ENV` direto, sem
 * passar pelo `core/config/env`, porque este módulo entra no Navbar e o
 * validador do env estoura a suíte de testes quando a variável não está
 * definida (o CI não tem `.env`).
 */
export const isPlaygroundEnabled = (): boolean =>
  import.meta.env.VITE_ENV !== "prod";
